import React, { Component, Fragment } from 'react';
import { Grid, Button } from 'semantic-ui-react';
import { Field } from 'redux-form';

import { InputField, SelectField, CheckboxField } from 'Common/SemanticWrapper';
import { ApplicationFieldEnum as Fields } from 'Common/FieldEnum';
import { ReduxFormButtonGroup } from 'Components/forms/ReduxFormButtonGroup';
import { APPLICATION_STUDENT_FORM_NAME } from 'Common/FormEnum';
import { setCaseTypeIdAfterDcOrCaseNumberChange } from '../../helpers/Helpers';
import EmancipatedMinorWarningDialog from './EmancipatedMinorWarningDialog';

class ExceptionsForm extends Component {
  state = {
    showDialog: false,
    seenDialog: false,
  };

  componentDidUpdate(prevProps) {
    //If the selected CaseTypeId is now not in the list of
    //case types provided (based on Is Direct Certified),
    //set to null
    const { caseTypes, values, change } = this.props;
    const caseTypeIds = caseTypes.map(caseType => caseType.value);

    if (!caseTypeIds.includes(values[Fields.CaseTypeId])) {
      change(`Exceptions.${Fields.CaseTypeId}`, null);
    }
  }

  groupOptions = [
    { key: 0, content: 'Foster', field: Fields.IsFoster },
    { key: 1, content: 'Kin-GAP', field: Fields.IsKinGap },
    {
      key: 2,
      content: 'Emancipated Minor',
      field: Fields.IsEmancipatedMinor,
    },
  ];

  hmrOptions = [
    { value: 1, label: 'Homeless' },
    { value: 2, label: 'Migrant' },
    { value: 3, label: 'Runaway' },
  ];

  caseTypeDisabled = () => {
    const { values } = this.props;
    const caseNumber = values[Fields.CaseNumber];
    const dc = values[Fields.IsDirectCertified];

    if (dc || (caseNumber && caseNumber.length > 0)) {
      return false;
    }

    return true;
  };

  onDirectCertifiedChange = (e, dc) => {
    const { values, change } = this.props;
    const caseNumber = values[Fields.CaseNumber];

    setCaseTypeIdAfterDcOrCaseNumberChange(dc, caseNumber, change);
  };

  onCaseNumberChange = (e, caseNumber) => {
    const { values, change } = this.props;
    const dc = values[Fields.IsDirectCertified];

    setCaseTypeIdAfterDcOrCaseNumberChange(dc, caseNumber, change);
  };

  onIsExtendedBenefitsChange = () => {
    const { values, change } = this.props;

    if (!values[Fields.IsExtendedBenefitsHasChanged]) {
      change(`Exceptions.${Fields.IsExtendedBenefitsHasChanged}`, true);
    }
  };

  onGroupClick = (e, field) => {
    e.preventDefault();
    const { values, change } = this.props;

    if (values[field]) {
      change(`Exceptions.${field}`, false);
    } else {
      this.groupOptions.forEach(option => {
        change(`Exceptions.${option.field}`, option.field === field);
      });
    }

    if (
      field === Fields.IsEmancipatedMinor &&
      !values[field] &&
      !this.state.seenDialog
    ) {
      this.setState({ showDialog: true, seenDialog: true });
    }
  };

  onDialogOkClick = () => this.setState({ showDialog: false });

  render() {
    const { caseTypes, values, dispatch, error } = this.props;

    return (
      <Fragment>
        <EmancipatedMinorWarningDialog
          showDialog={this.state.showDialog}
          onOkClick={this.onDialogOkClick}
        />
        <Grid>
          <Grid.Row>
            <Grid.Column width={4}>
              <Field
                className={'manage-application--dc-checkbox'}
                component={CheckboxField}
                label={'Direct Certified'}
                name={Fields.IsDirectCertified}
                onChange={this.onDirectCertifiedChange}
                disabled={this.props.isIncomplete}
              />
            </Grid.Column>
            <Grid.Column width={6}>
              <Field
                component={InputField}
                label={'Case #'}
                maxLength={20}
                name={Fields.CaseNumber}
                onChange={this.onCaseNumberChange}
              />
            </Grid.Column>
            <Grid.Column width={6}>
              <Field
                component={SelectField}
                disabled={this.caseTypeDisabled()}
                label={'Case Type'}
                name={Fields.CaseTypeId}
                options={caseTypes}
                style={{ zIndex: 100 }}
              />
            </Grid.Column>
          </Grid.Row>
          <Grid.Row
            className={'manage-application--exceptions-button-group-row'}
          >
            <Grid.Column width={8}>
              <Button.Group basic className="btn-group--active-group">
                {this.groupOptions.map(option => (
                  <Button
                    active={values[option.field]}
                    basic
                    className={'white'}
                    content={option.content}
                    key={option.key}
                    onClick={e => this.onGroupClick(e, option.field)}
                  />
                ))}
              </Button.Group>
            </Grid.Column>
            <Grid.Column width={8}>
              <ReduxFormButtonGroup
                unsettable
                dispatch={dispatch}
                formName={APPLICATION_STUDENT_FORM_NAME}
                fieldName={`Exceptions.${Fields.HMRCategory}`}
                value={values[Fields.HMRCategory]}
                options={this.hmrOptions}
              />
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column width={3}>
              <Field
                component={CheckboxField}
                label={'Head Start'}
                name={Fields.IsHeadStart}
                disabled={this.props.isIncomplete}
              />
            </Grid.Column>
            <Grid.Column width={6}>
              <Field
                component={CheckboxField}
                label={'Report as Extended Benefits'}
                name={Fields.IsExtendedBenefits}
                onChange={this.onIsExtendedBenefitsChange}
                disabled={this.props.isIncomplete}
              />
            </Grid.Column>
            <Grid.Column width={7}>
              {error && error[Fields.IsDirectCertified] ? (
                <span className={'error'}>
                  {error[Fields.IsDirectCertified]}
                </span>
              ) : null}
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Fragment>
    );
  }
}

export { ExceptionsForm };



// WEBPACK FOOTER //
// ./src/pages/manageapplication/components/student/ExceptionsForm.js